module.exports = __webpack_public_path__ + "img/pattern2.66b759a.svg";